const e=async(e,t)=>{await e.patch(`/users/${t}/restore`)};export{e as restoreUser};
//# sourceMappingURL=restore-user.mjs.map